import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus} from "../EventBus";
import PointManager from "../PointManager/PointManager";
import AngleManager from "../AngleManager/AngleManager";
import LineManager from "../LineManager";
import Circle from "../../../../../../src/entities/Circle";
import { Coord } from "../../../../../../src/types/Interface";
import { runCircleAnimation } from "./CircleAnimationSequence";
import CircleAnimationButton from "../../../../../../src/entities/UI/CircleAnimationButton/CircleAnimationButton";
import { INFO_SLIDER_COORD } from "../../types/Config";
import { ContextType } from "../../types/Interface";


export default class CircleAnimationManager {
  private isSwitcherActive:boolean = false;

  constructor(
    private PointManager: PointManager,
    private AngleManager: AngleManager,
    private LineManager: LineManager,
    private circle: Circle,
    private cCoord: Coord,
  ) {
    this.AngleManager.draw(PointManager.getRedPoints(), PointManager.getTangentCoords(), 0, true);
    eventBus.on(EnumEventBus.quasimodoMode, v => this.isSwitcherActive=v);
    this.addCircAnimBut();
  }
  getDelayForStartAnim = () => this.isSwitcherActive ? 1000 : 0;
  addCircAnimBut = () => new CircleAnimationButton( INFO_SLIDER_COORD, () => this.runAnimations(), () => this.getDelayForStartAnim());
  
  runAnimations() {
    rootEventBus.emit(EnumRootEventBus.startedCircleAnim);
    const context: ContextType = {
      PointManager: this.PointManager,
      AngleManager: this.AngleManager,
      LineManager: this.LineManager,
      circle: this.circle,
      cCoord: this.cCoord
    }

    runCircleAnimation(context, () => {
      rootEventBus.emit(EnumRootEventBus.getCircleCoord, { x: this.circle.x, y: this.circle.y })
      rootEventBus.emit(EnumRootEventBus.completedCircleAnim);
    });
  }
}
